'use client'

import React from 'react'
import { TimelineEventPrefix } from './partials/TimelineEventPrefix'
import { TimelineEventVariants } from './types/TimelineEventTypes'
import { TimelineEventProps } from './TimelineEvent'

export const TimelineEventListItem = ({
    children,
    prefix,
    variant = TimelineEventVariants.NONE,
    isFirst,
    isLast,
    ...props
}: Pick<TimelineEventProps, 'children' | 'prefix' | 'variant' | 'isFirst' | 'isLast' | 'className'>) => {
    const rootClass = 'timeline-item'

    const getRootClasses = (): string => {
        let classes = ''
        if (variant && variant !== 'none') classes += `${rootClass}--${variant} ${rootClass}--has-variant`
        if (isFirst) classes += ` ${rootClass}--first`
        if (isLast) classes += ` ${rootClass}--last`
        classes += ` ${props.className ?? ''}`
        return classes
    }

    return (
        <li {...props} className={`${rootClass} ${getRootClasses()}`} data-testid="timeline-event">
            <span className={`${rootClass}__line`} />
            <div className={`${rootClass}__content`}>
                <TimelineEventPrefix prefix={prefix} />
                {children}
            </div>
        </li>
    )
}
